/**
 * Uses GraphQL to load the list of questions by Tag from the backend.
 * @param areasForGrowth
 * @param lastScoreByItem
 * @param questionDataset
 * @param assignments
 * @param studentId {string | null}
 * @returns {object}
 */

const getQuestionsByTag = (
  areasForGrowth,
  lastScoreByItem,
  questionDataset,
  assignments,
  studentId = null,
) => {
  const learnosityActivityKey = Object.keys(lastScoreByItem)[0];
  const { users } = lastScoreByItem[learnosityActivityKey];
  /*
  users struct
  {
    userId: {
      items: {
        itemId: {
          score,
          max_score,
          item_number,
        },
        itemId2: { ... },
        ...
      }
    },
    usersId2: {

    },
    ...
  }
  */
  const assignment = assignments[0]; //get only the first assignment
  let userKeys = Object.keys(users);
  if (studentId) {
    userKeys = userKeys.filter((k) => k === studentId);
  }

  // reducing to get all scores of all users.
  // reduce users, accumulate the questions by mapping the user.items
  let allScores = userKeys.reduce(
    (questions, userId) =>
      questions.concat(
        Object.entries(users[userId].items).map((item) => {
          const [reference, itemScore] = item;
          return {
            reference,
            userId,
            score: itemScore.score,
            maxScore: itemScore.max_score,
            itemNumber: itemScore.item_number,
          };
        }),
      ),
    [],
  );

  return areasForGrowth.map((tag) => {
    const area = {
      ...tag,
      items: [],
    };
    area.itemsReferences.forEach((itemReference) => {
      const itemScores = allScores.filter((q) => q.reference === itemReference);
      const question = Object.values(questionDataset).find(
        (q) => q.learnosityItemReference === itemReference,
      );
      area.items.push({
        reference: itemReference,
        id: question.id,
        assignmentId: assignment.id,
        itemNumber: itemScores[0].itemNumber,
        avgScore: itemScores.reduce((sumAvgScore, item) => {
          const itemScore =
            (item.maxScore > 0 ? (item.score / item.maxScore) * 100 : 0) /
            itemScores.length;
          return sumAvgScore + itemScore;
        }, 0),
        scores: itemScores,
      });
      // sorting questions
      area.items = area.items.sort((q1, q2) => q1.itemNumber - q2.itemNumber);
    });
    let itemAvgScoreSum = 0;
    let itemCount = 0;
    area.items.forEach((item) => {
      itemAvgScoreSum += item.avgScore;
      itemCount++;
    });
    area.average_percentage = itemAvgScoreSum / itemCount;
    return area;
  });
};

export default getQuestionsByTag;
